import React from 'react';
import SkillList from './SkillList';

export default class SkillSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredSkills: [],
      term: ""
    };
    this.handleTermChange = this.handleTermChange.bind(this);
    this.filterSkillsByTerm = this.filterSkillsByTerm.bind(this);
    this.displayNoResults = this.displayNoResults.bind(this);
  }

  handleTermChange(e) {
    var newTerm = e.target.value.trim();
    var newlyFilteredSkills = newTerm !== ''? this.filterSkillsByTerm(this.props.skills, newTerm) : [];
    this.setState({
      term: newTerm,
      filteredSkills: newlyFilteredSkills
    });
  }

  filterSkillsByTerm(skills, term) {
    var result = skills.filter(function(skill){
      return skillMatchesTerm(skill, term);
    });
    return result;
  }

  displayNoResults() {
    return (
      <div className="skill-search-no-results">No skills match your search term.</div>
    );
  }

  render() {
    return (
      <div className="skill-search">
        <input className="skill-filter-field" type="text" placeholder="Filter by keyword" term={this.state.term} onChange={this.handleTermChange} />
        <SkillList 
          rootUrl={this.props.rootUrl}
          skills={this.state.term? this.state.filteredSkills : this.props.skills} 
          term={this.state.term} 
          canEdit={this.props.canEdit} 
          canDelete={this.props.canDelete} 
          deleteSkill={this.props.deleteSkill} />
        { this.state.term !== '' && this.state.filteredSkills.length == 0? this.displayNoResults() : null }
      </div>
    );
  }
}

function skillMatchesTerm(skill, term) {
  if (skill.name.toLowerCase() === term.toLowerCase()) {
    return true;
  }
  if (skill.name.toLowerCase().indexOf(term.toLowerCase()) != -1) {
    return true;
  }
  var aliases = skill.aliases.split(',').filter(function(alias){
    return alias.toLowerCase().indexOf(term.toLowerCase()) != -1;
  });
  return aliases.length > 0;
}
